/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$('.announcement-slider').flickity({
  	cellAlign: 'left',
  	contain: true,
    groupCells: 1,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: true,
    freeScroll: false,
   	autoPlay: 3000,
    arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
});

  $('.Categories-row').flickity({
  	cellAlign: 'left',
  	contain: true,
    groupCells: 1,
    pageDots: false,
    wrapAround: false,
    freeScroll: false,
   	autoplay: true,
    autoplaySpeed: 3000,
    arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
});

if ($(window).width() < 1024) {


  $('.celebrity-row').flickity({
  	cellAlign: 'left',
  	contain: true,
    groupCells: 1,
    pageDots: false,
    wrapAround: false,
    freeScroll: false,
   	autoplay: true,
    autoplaySpeed: 3000,
    arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
});

  $('.instagram-section').flickity({
  	cellAlign: 'left',
  	contain: true,
    groupCells: 1,
    pageDots: false,
    wrapAround: true,
    freeScroll: false,
   	autoplay: true,
    autoplaySpeed: 3000,
    arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
});
  
$('.customer-review-section').flickity({
  	cellAlign: 'left',
  	contain: true,
    groupCells: 1,
    pageDots: false,
    wrapAround: true,
    freeScroll: false,
   	autoplay: true,
    autoplaySpeed: 3000,
    arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
});

  $('.blog-slider').flickity({
  	cellAlign: 'left',
  	contain: true,
    groupCells: 1,
    pageDots: false,
    wrapAround: true,
    freeScroll: false,
   	autoplay: true,
    autoplaySpeed: 3000,
    arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
});
}

if ($(window).width() < 1007) {
      $('.home-product .ProductList--grid').flickity({
          cellAlign: 'left',
          contain: true,
          groupCells: 1,
          pageDots: false,
          wrapAround: false,
          freeScroll: false,
          autoplay: true,
          autoplaySpeed: 3000,
          arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
    });
  } 

if ($(window).width() < 850) {
  
//   $('.usp-icon-section').flickity({
//   	cellAlign: 'left',
//   	contain: true,
//     groupCells: 1,
//     pageDots: true,
//     prevNextButtons: false,
//     wrapAround: true,
//     freeScroll: false,
//    	autoplay: true,
//     autoplaySpeed: 3000,
//     arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
// });

   $('.recognitions-logo').flickity({
  	cellAlign: 'left',
  	contain: true,
    groupCells: 1,
    pageDots: true,
    prevNextButtons: false,
    wrapAround: true,
    freeScroll: false,
   	autoplay: true,
    autoplaySpeed: 3000,
    arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
});
}
if ($(window).width() < 767) {
  $(window).scroll(function(){
      if ($(this).scrollTop() > 50) {
         $('#Search').addClass('remove-search');
  			 console.log('bbom');
      } else {
         $('#Search').removeClass('remove-search');
      }
  });
}  

// Start: quick add to cart
$(function(){
  $('body').on('click','.ProductForm__AddToCart_custom', function(){  

if($(this).attr('url') == '/collections/gift-cards'){
   var variant_id = $(this).attr('data-vid');
 addItemToCartOneTime(variant_id,1)
}else{ 
 if($(this).parents('.cart-button').siblings('.swatics').attr('class') == 'swatics'){ 
        $(this).parents('.cart-button').siblings('ul.swatics').children('li').each(function(i,o){
        if($(o).attr('available') == 'true'){               
        addItemToCartOneTime($(o).attr('data-variant_js'),1)
        return false;
        }else{
        var variant_id = $(this).attr('data-vid');
        console.log(variant_id);
        addItemToCartOneTime(variant_id,1)
        } 
        
        }) 
 }else{
  var variant_id = $(this).attr('data-vid');
 addItemToCartOneTime(variant_id,1)
    
 }
} 
  });
 
  function addItemToCartOneTime (variant_id, quantity) {
    data = {
      "quantity": quantity,
      "id": variant_id,
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        $.getJSON('/cart.json', function(cart){

          var html_data ='';
          var cartTotalItem = cart.item_count;
          var cartTotalPrice = parseFloat(cart.total_price) / 100;

          // 		For update cart count
          if(cartTotalItem > 0){
            $('.Header__CartDot').addClass('is-visible');
            $('.Header__CartDot .Header__CartCount').text(cartTotalItem);
          }
          // 		End code for update cart count

          // Code for update mini cart
          // $.ajax({url: "/cart?section_id=mini-cart", 
          //         success: function(result) {
          //           console.log('---------------uuu')
          //           var successHtml = $($.parseHTML(result)).find("#sidebar-cart").html();

          // $("#sidebar-cart").html(successHtml);
          //   $(`.Header__CartDot`).trigger('click');
          // }});

          //  Code end for update mini cart
      });
        setTimeout(()=>{
            $.ajax({url: "/cart?section_id=mini-cart", 
                  success: function(result) {
                    console.log('---------------uuu')
                    var successHtml = $($.parseHTML(result)).find("#sidebar-cart").html();

          $("#sidebar-cart").html(successHtml);
            $(`.Header__CartDot`).trigger('click');
          }});
      },1000)
     }
    });
  }
});  

$(document).ready(function(){

    if ($(window).width() < 525) {

   $(".Footer__Block").click(function(){
        $(this).find(".Linklist").toggleClass("main");
    $(this).find(".footer-cutom").toggleClass("footer-cutom-opp");
});
}
});

if(navigator.vendor != null && navigator.vendor.match(/Apple Computer, Inc./) && navigator.userAgent.match(/iPhone/i) || (navigator.userAgent.match(/iPod/i))) 
    {
      //  alert("Ipod or Iphone---",$(window).width() );
    }
else if (navigator.vendor != null && navigator.vendor.match(/Apple Computer, Inc./) && navigator.userAgent.match(/iPad/i))  
    {
        //alert("Ipad---",$(window).width() );
    }
else if (navigator.vendor != null && navigator.vendor.match(/Apple Computer, Inc./) && navigator.userAgent.indexOf('Safari') != -1)
    {
      if($(window).width() < 1200){
$('.swatich-list').hide()
        setTimeout(()=>{
          $('.swatich-list').hide()
        },3000)
      }
       
    }

 if(window.location.href == 'https://www.everbloomindia.com/pages/swym-share-wishlist'){
 let js_engian =    setInterval(()=>{
   console.log('start')
   if($('.zprice').html() != 'undefined'){
     clearInterval(js_engian)
     setTimeout(()=>{
         
         $('#ZoomyWishlistPage .zprice').each(function(){
      $(this).text().split('R')[1]      
      const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'INR',
      });
    var newPrice =      formatter.format($(this).text().split('R')[1])
    $(this).text('Rs. '+newPrice.split('₹')[1])
     
      })

$('.removefromwishlist').on('click',function(){
  var data =   $(this).parents('li').siblings('li.zbodytitle').children('a').text()
  $('.Heading.u-h1').html(`<div class="removed-swem-js"> removed</div>  ${data}`)
    setTimeout(()=>{
 $('.Heading.u-h1').html(`Wishlist`)
      $('.removefromwishlist').length
if($('.removefromwishlist').length < 1){
   $('.PageHeader').append(`<div id="ZoomyWishlistPage" class="zooomywishlistgridclass"><p class="zmsg">Please add products in your wishlist to see them here.</p></div>`)
}
      },2000) 
  
})
       $('.addcartbtn').on('click',function(){
    $(this).parents('.ZoomyWishlistPageGrid').children().find('.removefromwishlist').trigger('click')
})

     },1500)     
   }
    },100)


   
  }
// $('#questionpopup').on('click', function(){

// $('#main_site_body').addClass('modal-open');
  
// });
  queen_price()
function queen_price(){
var finf_html = $('#quinn-cards-1')
var start_time = setInterval(()=>{
if(finf_html != 'undefined' || finf_html != null){
  clearInterval(start_time)
setTimeout(()=>{
$('.quinn_product_compare_at_price').each(function(){
 var com_p =  $(this).text()
   if(com_p.split('.')[1] == 'undefined' || com_p.split('.')[1] == undefined){
       var monay = com_p.split('.')[0].split('₹')[1]
     $(this).text('Rs. '+monay+'.00') 
   }
})

$('.quinn_product_price').each(function(){
 var com_p =  $(this).text()
   if(com_p.split('.')[1] == 'undefined' || com_p.split('.')[1] == undefined){
       var monay = com_p.split('.')[0].split('₹')[1]
     $(this).text('Rs. '+monay+'.00')  
   }
})

    $('.swiper-plugin-navigation-prevEl,.swiper-plugin-navigation-nextEl').on('click',function(){
queen_price()
  })
  
  },3000)
}
           
  },100)
}
$('#quinn-cards-1').on('click',function(){ 
    queen_price()
})

// checkout button price on cart drawer
var start_time_i = setInterval(()=>{   
if(window.page_type == 'cart'){
var money_ch_m = document.querySelector('.Cart__Total.Heading.u-h6 .money').innerHTML
if(money_ch_m.split('.')[1] == 'undefined' || money_ch_m.split('.')[1] == undefined){
var new_total =  money_ch_m.split('I')[0] + '.00 INR'
document.querySelector('.Cart__Total.Heading.u-h6 .money').innerHTML = new_total
}
}
// var money_ch = document.querySelector('.Cart__Checkout .money').innerHTML
// if(money_ch.split('.')[1] == 'undefined' || money_ch.split('.')[1] == undefined){
// var new_total =  money_ch.split('I')[0] + '.00 INR'
// document.querySelector('.Cart__Checkout .money').innerHTML = new_total

// }
  

  },500)

        // close modal
      
  document.querySelector('body').addEventListener('click',function(e){
    if(e.target.className == 'instafeed-lightbox'){
       document.querySelector('#close-button-url').click()
    }
})

$('.HorizontalList__Item label').on('click',function(){
   setTimeout(()=>{
    var  ProductMet = $('.ProductMeta__PriceList .money').text().split('.')[2] 
if(ProductMet == 'undefined' || ProductMet == undefined){
    $('.ProductMeta__PriceList .money').text( $('.ProductMeta__PriceList .money').text()+'.00')
}
       },500)
});

$('.size-tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('.size-tabs li').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
})


// hide country flag selector

 if (document.body.classList.contains('template-product') && window.innerWidth < 560) {
window.addEventListener("scroll", function() {
  var dynamicElement = document.body;
  if (window.scrollY > 70) {
      dynamicElement.classList.add("hideflag");
  } else {
      dynamicElement.classList.remove("hideflag");
  }
});
 }